import React, {useEffect, useState} from 'react';
import {
  Dimensions,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  View,
  TextInput,
  FlatList,
  TouchableOpacity,
  ScrollView,
  Modal,
  Image,
  ActivityIndicator,
  Alert,
} from 'react-native';
import {Picker} from '@react-native-picker/picker';
import axios from 'axios';
import {Formik} from 'formik';
import * as yup from 'yup';

import {BASE_URL} from '../../../components/BaseUrl';
import LeftBar from '../../../shared/LeftBar';
import LeftBarItem from '../../../shared/LeftBarItem';
import ErrorText from '../../../shared/errorText';
import {globalStyles} from '../../../styles/globalStyles';
import DateTimePickerModal from 'react-native-modal-datetime-picker';
import moment from 'moment';

import {DatePickerModal} from 'react-native-paper-dates';

const windowWidth = Dimensions.get('window').width;

const basicInfoSchema = yup.object({
  divisionName: yup.string().required('Division is required'),
  districtName: yup.string().required('District is required'),
 // grBranchId: yup.string().required('Lower Court is required'),
 // nameBng: yup.string().required('Thana/Area name is required'),
});

const basicInfoSearchSchema = yup.object({
  divisionName: yup.string().required('Division is required'),
  districtName: yup.string().required('District is required'),
});

export const AllAdalotImageCreateComponent = () => {
  // State declarations
  const [divisions, setDivisions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [lowerCourts, setLowerCourts] = useState([]);
   const [lower_court, setLowerCourt] = useState([]);
  const [thanas, setThanas] = useState([]);
  const [searchThanas, setSearchThanas] = useState([]);
  const [causeDate, setCauseDate] = useState(new Date());
  const [searchCauseDate, setSearchCauseDate] = useState(new Date());
  const [editDistricts, setEditDistricts] = useState([]);
  const [editLowerCourts, setEditLowerCourts] = useState([]);

  // Form states
  const [divisionId, setDivisionId] = useState('');
  const [districtId, setDistrictId] = useState('');
  const [searchDivisionId, setSearchDivisionId] = useState('');
  const [searchDistrictId, setSearchDistrictId] = useState('');
  const [searchThanaId, setSearchThanaId] = useState('');
  const [searchBranchId, setSearchBranchId] = useState('');
  const [searchLowerCourtId, setSearchLowerCourtId] = useState('');
  const [thanaId, setThanaId] = useState('');
  const [lowerCourtId, setLowerCourtId] = useState('');

  // Image states
  const [selectedImages, setSelectedImages] = useState([]);
  const [uploadingImages, setUploadingImages] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});

  // Data states
  const [allData, setAllData] = useState([]);

  // Edit modal states
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editDivisionId, setEditDivisionId] = useState('');
  const [editDistrictId, setEditDistrictId] = useState('');
  const [editLowerCourtId, setEditLowerCourtId] = useState('');
  const [editLowerCourtName, setEditLowerCourtName] = useState('');

  // Image update states
  const [isImageEditModalVisible, setIsImageEditModalVisible] = useState(false);
  const [editingImage, setEditingImage] = useState(null);
  const [editingImageFile, setEditingImageFile] = useState(null);
  const [uploadingUpdateImage, setUploadingUpdateImage] = useState(false);
  const [selectedUpdateImage, setSelectedUpdateImage] = useState(null);

  const [visible, setVisible] = useState(false);
  const [searchVisible, setSearchVisible] = useState(false);
  const locale = 'en';
  const pastDate = new Date(1900, 0, 1);
  const futureDate = new Date();

  const showDatePicker = () => {
    setVisible(true);
  };

  const hideDatePicker = () => {
    setVisible(false);
  };

  const onConfirmDate = ({date}) => {
    setCauseDate(date);
    hideDatePicker();
  };

  const showSearchDatePicker = () => {
    setSearchVisible(true);
  };

  const hideSearchDatePicker = () => {
    setSearchVisible(false);
  };

  const onConfirmSearchDate = ({date}) => {
    setSearchCauseDate(date);
    hideSearchDatePicker();
  };

  // Lifecycle effects
  useEffect(() => {
    fetchDivisions();
    fetchAllData();
  }, []);

  // API functions
  const fetchDivisions = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/GetDivission`);
      setDivisions(response.data || []);
    } catch (error) {
      console.log('Division Error:', error);
    }
  };

  const fetchDistrictsByDivision = async divisionId => {
    try {
      const formBody = `division_id=${encodeURIComponent(divisionId)}`;
      const response = await axios.post(
        `${BASE_URL}/DivisionToDistrict`,
        formBody,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        },
      );
      setDistricts(response.data || []);
      setDistrictId('');
      setThanaId('');
      setLowerCourtId('');
      setLowerCourts([]);
    } catch (error) {
      console.log('District Error:', error);
    }
  };

  const fetchEditDistrictsByDivision = async divisionId => {
    try {
      const formBody = `division_id=${encodeURIComponent(divisionId)}`;
      const response = await axios.post(
        `${BASE_URL}/DivisionToDistrict`,
        formBody,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        },
      );
      setEditDistricts(response.data || []);
    } catch (error) {
      console.log('District Error:', error);
    }
  };

const fetchLowerCourtsByDistrict = async districtId => {
  setLowerCourts([]);

  try {
    const dataToSend = {
      geo_division_id: divisionId,
      geo_district_id: districtId,
     
    };

      let formBody = [];
         for (let key in dataToSend) {
           let encodedKey = encodeURIComponent(key);
           let encodedValue = encodeURIComponent(dataToSend[key]);
           formBody.push(encodedKey + '=' + encodedValue);
         }
         formBody = formBody.join('&');
         //let url = `${BASE_URL}/CourtNameToLowerCourt`;  //Custom Old
         // let url = `${BASE_URL}/GetCourtNameAlldistrictToCourtNameNumber`;
         let url = `${BASE_URL}/DivisionAndDistrictToCourtName`;
         let response = await axios.post(url, formBody).then(res => res.data);

    setLowerCourt(response || []);

      setLowerCourts(
          response.map(marker => {
            marker.value = marker.id;
            marker.label = marker.office_name_bng;
            return marker;
          }),
        );
    setThanaId('');
    setLowerCourtId('');

  } catch (error) {
    console.log('Lower Court Error:', error);
  }
};

 const fetchLowerCourtsByBranch = async branchId => {
  try {
    const params = {
      geo_division_id: divisionId,
      geo_district_id: districtId,
      gr_branch_id: branchId,
      status:1
    };

    console.log('Fetching thanas with params:', params);

    const response = await axios.post(
      `${BASE_URL}/DivisionAndDistrictToCourtName`,
      {
        params,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    );

    setThanas(response.data || []);

    console.log('Response:', response.data);
  } catch (error) {
    console.log('Lower Court Error:', error);
  }
};

 const fetchLowerCourtsByBranchSearch = async BranchId => {
  try {
    const params = {
      geo_division_id: searchDivisionId,
      geo_district_id: searchDistrictId,
      gr_branch_id: BranchId,
      status:1
    };

    const response = await axios.post(
      `${BASE_URL}/DivisionAndDistrictToCourtName`,
      {
        params,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    );

    console.log('Thanas Response:', response.data);

    setSearchThanas(response.data || []);
  } catch (error) {
    console.log('Lower Court Error:', error);
  }
};

const fetchPoliceStationsByDistrict = async districtId => {
  try {
    const dataToSend = {
      geo_division_id: searchDivisionId,
      geo_district_id: districtId,
      
    };

  
         let formBody = [];
         for (let key in dataToSend) {
           let encodedKey = encodeURIComponent(key);
           let encodedValue = encodeURIComponent(dataToSend[key]);
           formBody.push(encodedKey + '=' + encodedValue);
         }
         formBody = formBody.join('&');
         //let url = `${BASE_URL}/CourtNameToLowerCourt`;  //Custom Old
         // let url = `${BASE_URL}/GetCourtNameAlldistrictToCourtNameNumber`;
         let url = `${BASE_URL}/DivisionAndDistrictToCourtName`;
         let response = await axios.post(url, formBody).then(res => res.data);

   // setLowerCourts(response.data || []);
  setLowerCourt(response || []);

      setLowerCourts(
          response.map(marker => {
            marker.value = marker.id;
            marker.label = marker.office_name_bng;
            return marker;
          }),
        );
    setThanaId('');
    setLowerCourtId('');

  } catch (error) {
    console.log('Lower Court Error:', error);
  }
};

 const fetchEditLowerCourtsByDistrict = async districtId => {
  try {
    const dataToSend = {
      geo_division_id: editDivisionId,
      geo_district_id: districtId,
     
    };

     let formBody = [];
         for (let key in dataToSend) {
           let encodedKey = encodeURIComponent(key);
           let encodedValue = encodeURIComponent(dataToSend[key]);
           formBody.push(encodedKey + '=' + encodedValue);
         }
         formBody = formBody.join('&');
         //let url = `${BASE_URL}/CourtNameToLowerCourt`;  //Custom Old
         // let url = `${BASE_URL}/GetCourtNameAlldistrictToCourtNameNumber`;
         let url = `${BASE_URL}/DivisionAndDistrictToCourtName`;
         let response = await axios.post(url, formBody).then(res => res.data);

   // setEditLower(response.data || []);
     setLowerCourt(response || []);

      setEditLowerCourts(
          response.map(marker => {
            marker.value = marker.id;
            marker.label = marker.office_name_bng;
            return marker;
          }),
        );
    setEditLowerCourtId('');
    setEditLowerCourtName('');

  } catch (error) {
    console.log('Lower Court Error:', error);
  }
};

  const fetchAllData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/GetAllThanaImages`);
      if (response.status == 200) {
        setAllData(response.data || []);
      }
    } catch (error) {
      console.log('Get All Data Error:', error);
    }
  };

  // ─── Image handling ───────────────────────────────────────────────────────────

  const handleImageSelect = event => {
    const files = Array.from(event.target.files);
    const newImages = files
      .filter(file => file.type.startsWith('image/'))
      .map(file => ({
        file,
        preview: URL.createObjectURL(file),
        id: Date.now() + Math.random(),
        name: file.name,
        size: file.size,
        type: file.type,
      }));
    setSelectedImages(prev => [...prev, ...newImages]);
  };

  const handleUpdateImageSelect = event => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setSelectedUpdateImage({
        file,
        preview: URL.createObjectURL(file),
        name: file.name,
        size: file.size,
      });
    }
  };

  const handleDragOver = e => {
    e.preventDefault();
  };

  const handleDrop = e => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    const newImages = files
      .filter(file => file.type.startsWith('image/'))
      .map(file => ({
        file,
        preview: URL.createObjectURL(file),
        id: Date.now() + Math.random(),
        name: file.name,
        size: file.size,
        type: file.type,
      }));
    setSelectedImages(prev => [...prev, ...newImages]);
  };

  const removeImage = imageId => {
    setSelectedImages(prev => {
      const removed = prev.find(img => img.id === imageId);
      if (removed?.preview) URL.revokeObjectURL(removed.preview);
      return prev.filter(img => img.id !== imageId);
    });
  };

  const formatFileSize = bytes => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / 1048576).toFixed(1) + ' MB';
  };

  // ─── Other handlers ───────────────────────────────────────────────────────────

  const handleSearch = async () => {
    if (!searchDivisionId || !searchDistrictId) {
      alert('Please select both division and district to search');
      return;
    }
    try {
      const response = await axios.get(`${BASE_URL}/GetCourtImages`, {
        params: {
          lower_court_id: searchLowerCourtId,
          status: 1,
          cause_date: searchCauseDate
            ? moment(searchCauseDate).format('YYYY-MM-DD')
            : undefined,
        },
      });
      console.log('Search Response:', response.data);
      if (response.status == 200) setAllData(response.data);
    } catch (error) {
      console.log('Get All Data Error:', error);
    }
  };

  const handleSubmitForm = async values => {
    if (selectedImages.length === 0) {
      alert('Please select at least one image');
      return;
    }

    if (!causeDate) {
      alert('Please select a date');
      return;
    }

    const formData = new FormData();
    selectedImages.forEach(image => {
      formData.append('files', image.file, image.name);
    });
    formData.append('cause_date', moment(causeDate).format('YYYY-MM-DD'));
    formData.append('lower_court_id', lowerCourtId);

    try {
      setUploadingImages(true);
      await axios.post(`${BASE_URL}/UploadCourtMultipleImages`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: progressEvent => {
          const progress = Math.round(
            (progressEvent.loaded * 100) / (progressEvent.total || 1),
          );
          setUploadProgress(prev => ({...prev, global: progress}));
        },
      });

      alert('Data added successfully');
      fetchAllData();
      setDivisionId('');
      setDistrictId('');
      setLowerCourtId('');
      setThanaId('');
      setCauseDate(null);
      setSelectedImages([]);
      setUploadProgress({});
    } catch (error) {
      console.log('Submit Error:', error?.response?.data || error.message);
      alert('Error adding data');
    } finally {
      setUploadingImages(false);
    }
  };

  // Handle image update/delete
  const handleUpdateImage = async item => {
    setEditingImage(item);
    setSelectedUpdateImage(null);
    setIsImageEditModalVisible(true);
  };

  const handleDeleteImage = async item => {
    Alert.alert(
      'Confirm Delete',
      'Are you sure you want to delete this image?',
      [
        {text: 'Cancel', style: 'cancel'},
        {
          text: 'Delete',
          style: 'destructive',
          onPress: async () => {
            try {
              await axios.delete(`${BASE_URL}/DeleteThanaImage/${item.id}`);
              alert('Image deleted successfully');
              fetchAllData();
            } catch (error) {
              console.log('Delete Error:', error);
              alert('Error deleting image');
            }
          },
        },
      ],
    );
  };

  const handleSaveImageUpdate = async () => {
    if (!selectedUpdateImage && !editingImage) {
      alert('Please select a new image');
      return;
    }

    setUploadingUpdateImage(true);

    try {
      const formData = new FormData();

      if (selectedUpdateImage) {
        formData.append(
          'file',
          selectedUpdateImage.file,
          selectedUpdateImage.name,
        );
      }
      formData.append('id', editingImage.id);
      formData.append(
        'cause_date',
        moment(searchCauseDate).format('YYYY-MM-DD'),
      );
      formData.append('diary_police_station_id', searchThanaId);

      await axios.post(`${BASE_URL}/UpdateThanaImage`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      alert('Image updated successfully');
      setIsImageEditModalVisible(false);
      setEditingImage(null);
      setSelectedUpdateImage(null);
      fetchAllData();
    } catch (error) {
      console.log('Update Error:', error);
      alert('Error updating image');
    } finally {
      setUploadingUpdateImage(false);
    }
  };

  const handleEditData = async item => {
    setIsEditModalVisible(true);
    setEditId(item.id);
    setEditDivisionId(item.geo_division_id?.toString());
    await fetchEditDistrictsByDivision(item.geo_division_id?.toString());
    setEditDistrictId(item.geo_district_id?.toString());
    await fetchEditLowerCourtsByDistrict(item.geo_district_id?.toString());
    setEditLowerCourtId(item.gr_branch_id?.toString());
    setEditLowerCourtName(item.name_bng?.toString());
  };

  const handleUpdateData = async () => {
    if (!editLowerCourtName || !editDivisionId || !editDistrictId) {
      alert('Please fill all fields');
      return;
    }

    const payload = {
      id: editId,
      geo_division_id: editDivisionId,
      geo_district_id: editDistrictId,
      gr_branch_id: editLowerCourtId,
      name_bng: editLowerCourtName,
      status: 1,
    };

    let formBody = [];
    for (let key in payload) {
      formBody.push(
        encodeURIComponent(key) + '=' + encodeURIComponent(payload[key]),
      );
    }
    formBody = formBody.join('&');

    try {
      await axios.post(`${BASE_URL}/PoliceStationUpdate`, formBody);
      alert('Data updated successfully');
      handleCloseEditModal();
      fetchAllData();
    } catch (error) {
      console.log('Update Error:', error);
      alert('Error updating data');
    }
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setEditId(null);
    setEditDivisionId('');
    setEditDistrictId('');
    setEditLowerCourtId('');
    setEditLowerCourtName('');
    setEditDistricts([]);
    setEditLowerCourts([]);
  };

  // Group images in rows of 3 for FlatList
  const groupImagesIntoRows = data => {
    const rows = [];
    for (let i = 0; i < data.length; i += 3) {
      rows.push(data.slice(i, i + 3));
    }
    return rows;
  };

  // Row-based render for 3 images per row with update/delete buttons
  const renderImageRow = ({item}) => (
    <View style={styles.imageRow}>
      {item.map((image, idx) => (
        <View key={image.id || idx} style={styles.imageRowItem}>
          <Image
            source={{uri: 'https://api.bdjudgecourt.com' + image.file_path}}
            style={styles.rowImage}
            resizeMode="cover"
          />
          <View style={styles.imageOverlay}>
            <Pressable
              style={[styles.imageActionBtn, styles.updateBtn]}
              onPress={() => handleUpdateImage(image)}
            >
              <Text style={styles.actionBtnText}>Edit</Text>
            </Pressable>
            {/* <Pressable
              style={[styles.imageActionBtn, styles.deleteBtn]}
              onPress={() => handleDeleteImage(image)}
            >
              <Text style={styles.actionBtnText}>Delete</Text>
            </Pressable> */}
          </View>
        </View>
      ))}
      {/* Fill empty slots if less than 3 images */}
      {item.length < 3 &&
        [...Array(3 - item.length)].map((_, idx) => (
          <View key={`empty-${idx}`} style={styles.imageRowItem} />
        ))}
    </View>
  );

  // ─── Image Preview Renderer ───────────────────────────────────────────────────

  const renderImagePreview = () => {
    if (selectedImages.length === 0) return null;

    return (
      <View style={styles.imagePreviewContainer}>
        <View style={styles.previewSummaryRow}>
          <Text style={styles.imagePreviewTitle}>
            {selectedImages.length} image
            {selectedImages.length > 1 ? 's' : ''} selected
          </Text>
          <TouchableOpacity
            onPress={() => setSelectedImages([])}
            disabled={uploadingImages}
          >
            <Text style={styles.clearAllText}>Clear all</Text>
          </TouchableOpacity>
        </View>

        <View style={styles.previewCardsContainer}>
          {selectedImages.map(image => (
            <View key={image.id} style={styles.previewCard}>
              <Image
                source={{uri: image.preview}}
                style={styles.imagePreview}
              />
              <TouchableOpacity
                style={styles.removeImageButton}
                onPress={() => removeImage(image.id)}
                disabled={uploadingImages}
              >
                <Text style={styles.removeImageText}>×</Text>
              </TouchableOpacity>
              {uploadProgress[image.id] > 0 && uploadingImages && (
                <View style={styles.uploadProgressOverlay}>
                  <Text style={styles.uploadProgressText}>
                    {uploadProgress[image.id]}%
                  </Text>
                </View>
              )}
              <View style={styles.previewFooter}>
                <Text style={styles.imageName} numberOfLines={1}>
                  {image.name}
                </Text>
                <Text style={styles.imageSize}>
                  {formatFileSize(image.size)}
                </Text>
                {uploadProgress[image.id] > 0 && uploadingImages && (
                  <View style={styles.uploadBarWrap}>
                    <View
                      style={[
                        styles.uploadBar,
                        {width: `${uploadProgress[image.id]}%`},
                      ]}
                    />
                  </View>
                )}
              </View>
            </View>
          ))}
        </View>
      </View>
    );
  };

  // ─── Render ───────────────────────────────────────────────────────────────────

  return (
    <ScrollView>
      <View
        style={
          Platform.OS === 'web' && windowWidth >= 600
            ? globalStyles.mainContainerAdmin
            : globalStyles.mainContainerMobile
        }
      >
        <LeftBar>
          <LeftBarItem
            selectcolor="true"
            name="ড্যাসবোর্ড"
            stack="Dashboard"
            screen="DashboardScreen"
          />
          <LeftBarItem
            selectcolor="true"
            name="জি আর শাখা আদালত"
            stack="অ্যাডমিন"
            screen="grBranchAdalot"
          />
          <LeftBarItem
            selectcolor="true"
            name="জি আর থানা/অঞ্চল"
            stack="অ্যাডমিন"
            screen="grThanaArea"
          />
          <LeftBarItem
            selectcolor="true"
            name="জি আর কার্জতালিকার ছবি"
            stack="অ্যাডমিন"
            screen="grAdalotCreate"
          />
          <LeftBarItem
            selectcolor="true"
            name="কার্জতালিকার ছবি"
            stack="অ্যাডমিন"
            screen="AllAdalotImageCreate"
          />
        </LeftBar>

        <View
          style={
            Platform.OS === 'web' && windowWidth >= 600
              ? globalStyles.bodyContainer
              : globalStyles.bodyContainerMobile
          }
        >
          {/* ── Create Form ── */}
          <Formik
            initialValues={{
              divisionName: '',
              districtName: '',
              lowerCourtId: '',
              nameBng: '',
            }}
            validationSchema={basicInfoSchema}
            onSubmit={handleSubmitForm}
          >
            {({
              handleChange,
              handleSubmit,
              setFieldTouched,
              touched,
              errors,
            }) => (
              <>
                <View style={styles.formWrapper}>
                  {/* Division */}
                  <View style={styles.formGroup}>
                    <View style={styles.pickerWrapper}>
                      <Picker
                        selectedValue={divisionId || ''}
                        style={styles.picker}
                        onValueChange={itemValue => {
                          setDivisionId(itemValue);
                          fetchDistrictsByDivision(itemValue);
                          handleChange('divisionName')(itemValue);
                          setFieldTouched('divisionName', true);
                        }}
                        mode="dropdown"
                      >
                        <Picker.Item
                          label="বিভাগ নির্বাচন করুনঃ–"
                          value=""
                          color="red"
                        />
                        {divisions.map((item, index) => (
                          <Picker.Item
                            key={index}
                            label={item.division_name_bng?.toString()}
                            value={item.geo_division_id?.toString()}
                          />
                        ))}
                      </Picker>
                    </View>
                    {touched.divisionName && errors.divisionName && (
                      <ErrorText>{errors.divisionName}</ErrorText>
                    )}
                  </View>

                  {/* District */}
                  <View style={styles.formGroup}>
                    <View style={styles.pickerWrapper}>
                      <Picker
                        selectedValue={districtId || ''}
                        style={styles.picker}
                        onValueChange={itemValue => {
                          setDistrictId(itemValue);
                          fetchLowerCourtsByDistrict(itemValue);
                          handleChange('districtName')(itemValue);
                          setFieldTouched('districtName', true);
                        }}
                        mode="dropdown"
                      >
                        <Picker.Item
                          label="জেলা নির্বাচন করুনঃ–"
                          value=""
                          color="red"
                        />
                        {districts.map((item, index) => (
                          <Picker.Item
                            key={index}
                            label={item.district_name_bng?.toString()}
                            value={item.geo_district_id?.toString()}
                          />
                        ))}
                      </Picker>
                    </View>
                    {touched.districtName && errors.districtName && (
                      <ErrorText>{errors.districtName}</ErrorText>
                    )}
                  </View>

                  {/* Lower Court */}
                  <View style={styles.formGroup}>
                    <View style={styles.pickerWrapper}>
                      <Picker
                        selectedValue={lowerCourtId || ''}
                        style={styles.picker2}
                        onValueChange={itemValue => {
                          setLowerCourtId(itemValue);
                          handleChange('lowerCourtId')(itemValue);
                          fetchLowerCourtsByBranch(itemValue);
                          setFieldTouched('lowerCourtId', true);
                        }}
                        mode="dropdown"
                      >
                        <Picker.Item
                          label="আদালতের নাম নির্বাচন করুনঃ–"
                          value=""
                          color="red"
                        />
                        {lowerCourts.map((item, index) => (
                          <Picker.Item
                            key={index}
                            label={item.label?.toString()}
                            value={item.value?.toString()}
                          />
                        ))}
                      </Picker>
                    </View>
                    {touched.lowerCourtId && errors.lowerCourtId && (
                      <ErrorText>{errors.lowerCourtId}</ErrorText>
                    )}
                  </View>

                  {/* Thana Picker */}
                  {/* <View style={styles.formGroup}>
                    <View style={styles.pickerWrapper}>
                      <Picker
                        selectedValue={thanaId || ''}
                        style={styles.picker2}
                        onValueChange={itemValue => {
                          setThanaId(itemValue);
                          handleChange('nameBng')(itemValue);
                          setFieldTouched('nameBng', true);
                        }}
                        mode="dropdown"
                      >
                        <Picker.Item
                          label="থানা/অঞ্চল নির্বাচন করুনঃ–"
                          value=""
                          color="red"
                        />
                        {thanas.map((item, index) => (
                          <Picker.Item
                            key={index}
                            label={item.name_bng?.toString()}
                            value={item.gr_branch_id?.toString()}
                          />
                        ))}
                      </Picker>
                    </View>
                    {touched.nameBng && errors.nameBng && (
                      <ErrorText>{errors.nameBng}</ErrorText>
                    )}
                  </View> */}

                  <View style={styles.formGroup}>
                    <View style={styles.pickerWrapper}>
                      <TouchableOpacity
                        onPress={showDatePicker}
                        style={styles.sectionStyle}
                      >
                        <TextInput
                          style={styles.inputs1}
                          value={
                            causeDate
                              ? moment(causeDate).format('DD-MM-YYYY')
                              : ''
                          }
                          placeholder="DD-MM-YYYY"
                          placeholderTextColor="#999"
                          editable={false}
                          pointerEvents="none"
                        />
                        <Image
                          source={{
                            uri: 'https://bdjudgecourt.com/assets/calendar.png',
                          }}
                          style={styles.imageStyle}
                        />
                      </TouchableOpacity>
                    </View>
                    {!causeDate && <ErrorText>Please select a date</ErrorText>}
                  </View>

                  {/* Image Upload Section */}
                  <View style={styles.imageUploadSection}>
                    <Text style={styles.imageUploadLabel}>Upload Images</Text>

                    <div
                      style={styles.dropzoneWeb}
                      onDragOver={handleDragOver}
                      onDrop={handleDrop}
                      onClick={() =>
                        document.getElementById('imageFileInput').click()
                      }
                    >
                      <input
                        type="file"
                        accept="image/*"
                        multiple
                        id="imageFileInput"
                        onChange={handleImageSelect}
                        style={{display: 'none'}}
                        disabled={uploadingImages}
                      />
                      <Text style={styles.dropzoneIconText}>☁</Text>
                      <Text style={styles.dropzoneMainText}>
                        Drag & drop images here, or{' '}
                        <Text style={styles.dropzoneBrowse}>browse files</Text>
                      </Text>
                      <Text style={styles.dropzoneSubText}>
                        PNG, JPG, WEBP — up to 10MB each
                      </Text>
                    </div>

                    {renderImagePreview()}

                    {uploadingImages && (
                      <View style={styles.uploadingIndicator}>
                        <ActivityIndicator size="small" color="#185FA5" />
                        <Text style={styles.uploadingText}>
                          Uploading images…
                        </Text>
                      </View>
                    )}
                  </View>

                  <Pressable
                    style={styles.submitButton}
                    onPress={handleSubmit}
                    disabled={uploadingImages}
                  >
                    <Text style={styles.submitButtonText}>
                      {uploadingImages ? 'Uploading…' : 'Submit'}
                    </Text>
                  </Pressable>
                </View>
              </>
            )}
          </Formik>

          <DatePickerModal
            locale={locale}
            mode="single"
            visible={visible}
            onDismiss={hideDatePicker}
            date={causeDate || new Date()}
            onConfirm={onConfirmDate}
            validRange={{
              startDate: pastDate,
              endDate: futureDate,
            }}
          />

          <DatePickerModal
            locale={locale}
            mode="single"
            visible={searchVisible}
            onDismiss={hideSearchDatePicker}
            date={searchCauseDate || new Date()}
            onConfirm={onConfirmSearchDate}
            validRange={{
              startDate: pastDate,
              endDate: futureDate,
            }}
          />

          {/* ── Search Section ── */}
          <View style={styles.wrapper}>
            <Formik
              initialValues={{
                divisionName: '',
                districtName: '',
                searchLowerCourtId: '',
               
              }}
              validationSchema={basicInfoSearchSchema}
              onSubmit={handleSearch}
            >
              {({
                handleChange,
                handleSubmit,
                setFieldTouched,
                touched,
                errors,
              }) => (
                <>
                  <View style={[styles.formWrapperSearch]}>
                    {/* Division */}
                    <View style={styles.formGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={searchDivisionId || ''}
                          style={[styles.picker, {width: 80}]}
                          onValueChange={itemValue => {
                            setSearchDivisionId(itemValue);
                            fetchDistrictsByDivision(itemValue);
                            handleChange('divisionName')(itemValue);
                            setFieldTouched('divisionName', true);
                          }}
                          mode="dropdown"
                        >
                          <Picker.Item label="বিভাগ" value="" color="red" />
                          {divisions.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.division_name_bng?.toString()}
                              value={item.geo_division_id?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                    </View>

                    {/* District */}
                    <View style={styles.formGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={searchDistrictId || ''}
                          style={[styles.picker, {width: 100}]}
                          onValueChange={itemValue => {
                            setSearchDistrictId(itemValue);
                            fetchPoliceStationsByDistrict(itemValue);
                            handleChange('districtName')(itemValue);
                            setFieldTouched('districtName', true);
                          }}
                          mode="dropdown"
                        >
                          <Picker.Item label="জেলা" value="" color="red" />
                          {districts.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.district_name_bng?.toString()}
                              value={item.geo_district_id?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                    </View>

                    {/* Branch Name */}
                    <View style={styles.formGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={searchLowerCourtId || ''}
                          style={[styles.picker2, {width: 285}]}
                          onValueChange={itemValue => {
                            setSearchLowerCourtId(itemValue);
                            handleChange('searchLowerCourtId')(itemValue);
                            fetchLowerCourtsByBranchSearch(itemValue);
                            setFieldTouched('searchLowerCourtId', true);
                          }}
                          mode="dropdown"
                        >
                          <Picker.Item label="আদালতের নাম" value="" color="red" />
                          {lowerCourts.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.label?.toString()}
                              value={item.value?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                    </View>

                    {/* Thana Picker */}
                    {/* <View style={styles.formGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={searchThanaId || ''}
                          style={[styles.picker2, {width: 155}]}
                          onValueChange={itemValue => {
                            setSearchThanaId(itemValue);
                            handleChange('nameBng')(itemValue);
                            setFieldTouched('nameBng', true);
                          }}
                          mode="dropdown"
                        >
                          <Picker.Item
                            label="থানা/অঞ্চল"
                            value=""
                            color="red"
                          />
                          {searchThanas.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.name_bng?.toString()}
                              value={item.gr_branch_id?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                    </View> */}

                    <View style={styles.formGroup}>
                      <View style={styles.pickerWrapper}>
                        <TouchableOpacity
                          onPress={showSearchDatePicker}
                          style={styles.sectionStyle}
                        >
                          <TextInput
                            style={styles.inputs1}
                            value={
                              searchCauseDate
                                ? moment(searchCauseDate).format('DD-MM-YYYY')
                                : ''
                            }
                            placeholder="DD-MM-YYYY"
                            placeholderTextColor="#999"
                            editable={false}
                            pointerEvents="none"
                          />
                          <Image
                            source={{
                              uri: 'https://bdjudgecourt.com/assets/calendar.png',
                            }}
                            style={styles.imageStyle}
                          />
                        </TouchableOpacity>
                      </View>
                    </View>

                    <Pressable
                      style={styles.submitButton}
                      onPress={handleSubmit}
                    >
                      <Text style={styles.submitButtonText}>Search</Text>
                    </Pressable>
                  </View>
                </>
              )}
            </Formik>

            {/* Images Grid with Update/Delete buttons */}
            <FlatList
              data={groupImagesIntoRows(allData)}
              keyExtractor={(item, index) => index.toString()}
              renderItem={renderImageRow}
              showsVerticalScrollIndicator={true}
              scrollEnabled={true}
              ListEmptyComponent={
                <View style={styles.emptyContainer}>
                  <Text style={styles.emptyText}>No data found</Text>
                </View>
              }
            />
          </View>
        </View>
      </View>

      {/* Image Edit Modal */}
      <Modal
        animationType="slide"
        transparent={true}
        visible={isImageEditModalVisible}
        onRequestClose={() => setIsImageEditModalVisible(false)}
      >
        
          <View style={styles.modalOverlay}>
            <View style={styles.modalContainer}>
              <Text style={styles.modalTitle}>Update Image</Text>

              {/* Current Image */}
              {editingImage && !selectedUpdateImage && (
                <>
                  <Text style={styles.modalLabel}>Current Image</Text>
                  <Image
                    source={{
                      uri:
                        'https://api.bdjudgecourt.com' + editingImage.file_path,
                    }}
                    style={styles.editImagePreview}
                    resizeMode="cover"
                  />
                </>
              )}

              {/* New Image Preview */}
              {selectedUpdateImage && (
                <>
                  <Text style={styles.modalLabel}>New Image</Text>
                  <Image
                    source={{uri: selectedUpdateImage.preview}}
                    style={styles.editImagePreview}
                    resizeMode="cover"
                  />
                  <Text style={styles.imageName}>
                    {selectedUpdateImage.name}
                  </Text>
                  <Text style={styles.imageSize}>
                    {formatFileSize(selectedUpdateImage.size)}
                  </Text>
                </>
              )}

              {/* Image Upload */}
              <div
                style={styles.editDropzone}
                onClick={() =>
                  document.getElementById('updateImageInput').click()
                }
              >
                <input
                  type="file"
                  accept="image/*"
                  id="updateImageInput"
                  onChange={handleUpdateImageSelect}
                  style={{display: 'none'}}
                  disabled={uploadingUpdateImage}
                />
                <Text style={styles.dropzoneIconText}>📷</Text>
                <Text style={styles.dropzoneMainText}>
                  Click to select new image
                </Text>
              </div>

              {/* Modal Buttons */}
              <View style={styles.modalButtonContainer}>
                <TouchableOpacity
                  style={[styles.modalButton, styles.cancelButton]}
                  onPress={() => {
                    setIsImageEditModalVisible(false);
                    setEditingImage(null);
                    setSelectedUpdateImage(null);
                  }}
                >
                  <Text style={styles.cancelButtonText}>Cancel</Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={[styles.modalButton, styles.updateButton]}
                  onPress={handleSaveImageUpdate}
                  disabled={uploadingUpdateImage}
                >
                  <Text style={styles.updateButtonText}>
                    {uploadingUpdateImage ? 'Updating...' : 'Update'}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
   
      </Modal>

      {/* ── Edit Modal for Police Station ── */}
      <Modal
        animationType="slide"
        transparent={true}
        visible={isEditModalVisible}
        onRequestClose={handleCloseEditModal}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContainer}>
            <Text style={styles.modalTitle}>Edit Data</Text>

            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Division</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editDivisionId || ''}
                  style={styles.modalPicker}
                  onValueChange={async itemValue => {
                    setEditDivisionId(itemValue);
                    await fetchEditDistrictsByDivision(itemValue);
                    setEditDistrictId('');
                  }}
                  mode="dropdown"
                >
                  <Picker.Item
                    label="বিভাগ নির্বাচন করুনঃ–"
                    value=""
                    color="red"
                  />
                  {divisions.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.division_name_bng?.toString()}
                      value={item.geo_division_id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>District</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editDistrictId || ''}
                  style={styles.modalPicker}
                  onValueChange={async itemValue => {
                    setEditDistrictId(itemValue);
                    await fetchEditLowerCourtsByDistrict(itemValue);
                  }}
                  mode="dropdown"
                >
                  <Picker.Item
                    label="জেলা নির্বাচন করুনঃ–"
                    value=""
                    color="red"
                  />
                  {editDistricts.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.district_name_bng?.toString()}
                      value={item.geo_district_id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Branch Name</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editLowerCourtId || ''}
                  style={styles.modalPicker}
                  onValueChange={itemValue => {
                    setEditLowerCourtId(itemValue);
                    const selected = editLowerCourts.find(
                      item => item.id?.toString() === itemValue,
                    );
                    setEditLowerCourtName(selected?.name_bng || '');
                  }}
                  mode="dropdown"
                >
                  <Picker.Item
                    label="শাখার নাম নির্বাচন করুনঃ–"
                    value=""
                    color="red"
                  />
                  {editLowerCourts.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.name_bng?.toString()}
                      value={item.id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Thana / Area Name</Text>
              <View style={styles.modalInputWrapper}>
                <TextInput
                  placeholder="থানা / অঞ্চল লিখুন"
                  placeholderTextColor="#999"
                  style={styles.modalTextInput}
                  value={editLowerCourtName}
                  onChangeText={setEditLowerCourtName}
                  editable={true}
                />
              </View>
            </View>

            <View style={styles.modalButtonContainer}>
              <TouchableOpacity
                style={[styles.modalButton, styles.cancelButton]}
                onPress={handleCloseEditModal}
              >
                <Text style={styles.cancelButtonText}>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.modalButton, styles.updateButton]}
                onPress={handleUpdateData}
              >
                <Text style={styles.updateButtonText}>Update</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </ScrollView>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  formWrapper: {
    width: '96%',
    marginLeft: '2%',
    marginTop: 12,
    marginBottom: 12,
    paddingVertical: 24,
    paddingHorizontal: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    backgroundColor: '#ffffff',
    borderRadius: 18,
    borderWidth: 1,
    borderColor: '#e8eefc',
    shadowColor: '#0f172a',
    shadowOffset: {width: 0, height: 10},
    shadowOpacity: 0.08,
    shadowRadius: 20,
    elevation: 8,
  },
  formWrapperSearch: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    marginBottom: 20,
  },
  formGroup: {
    marginBottom: 14,
    marginHorizontal: 8,
  },
  pickerWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 4,
    backgroundColor: '#fff',
    overflow: 'hidden',
    height: Platform.OS === 'web' && windowWidth >= 600 ? 30 : 30,
  },
  sectionStyle: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    backgroundColor: '#fff',
    borderColor: '#000',
    borderRadius: 4,
    height: Platform.OS === 'web' && windowWidth >= 600 ? 30 : 30,
    position: 'relative',
  },
  imageStyle: {
    position: 'absolute',
    width: 20,
    height: 20,
    right: 8,
  },
  inputs1: {
    borderRadius: 2,
    fontSize: 13,
    width: 120,
    backgroundColor: '#fff',
  },
  picker: {
    height: Platform.OS === 'web' && windowWidth >= 600 ? 42 : 50,
    width: '100%',
    color: '#333',
  },
  picker2: {
    height: Platform.OS === 'web' && windowWidth >= 600 ? 42 : 50,
    width: '100%',
    color: '#333',
  },
  submitButton: {
    backgroundColor: '#007bff',
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 4,
    alignSelf: 'flex-start',
    marginLeft: '2%',
  },
  submitButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
  wrapper: {
    width: '96%',
    marginLeft: '2%',
    marginTop: 24,
    marginBottom: 20,
    paddingVertical: 20,
    paddingHorizontal: 16,
    backgroundColor: '#fff',
    borderRadius: 18,
    borderWidth: 1,
    borderColor: '#e8eefc',
    shadowColor: '#0f172a',
    shadowOffset: {width: 0, height: 10},
    shadowOpacity: 0.08,
    shadowRadius: 20,
    elevation: 8,
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 50,
  },
  emptyText: {
    fontSize: 16,
    color: '#999',
    fontWeight: '500',
  },

  // ── Image Upload Styles ──────────────────────────────────────────────────────────

  imageUploadSection: {
    width: '100%',
    marginTop: 14,
    marginBottom: 10,
    paddingHorizontal: 8,
  },
  imageUploadLabel: {
    fontSize: 11,
    fontWeight: '600',
    color: '#64748b',
    letterSpacing: 1,
    textTransform: 'uppercase',
    marginBottom: 10,
  },

  dropzoneWeb: {
    border: '1.5px dashed #94a3b8',
    borderRadius: 12,
    padding: '28px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: 6,
    cursor: 'pointer',
    backgroundColor: '#f8fafc',
  },
  dropzoneIconText: {
    fontSize: 28,
    color: '#378ADD',
    marginBottom: 4,
    textAlign: 'center',
  },
  dropzoneMainText: {
    fontSize: 14,
    color: '#64748b',
    textAlign: 'center',
  },
  dropzoneBrowse: {
    color: '#185FA5',
    fontWeight: '600',
  },
  dropzoneSubText: {
    fontSize: 12,
    color: '#94a3b8',
    marginTop: 2,
    textAlign: 'center',
    paddingBottom: 16,
  },

  imagePreviewContainer: {
    marginTop: 14,
  },
  previewSummaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  imagePreviewTitle: {
    fontSize: 12,
    color: '#64748b',
    fontWeight: '500',
  },
  clearAllText: {
    fontSize: 12,
    color: '#A32D2D',
    fontWeight: '500',
  },
  previewCardsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  previewCard: {
    width: '31.33%',
    marginBottom: 10,
    borderWidth: 0.5,
    borderColor: '#e2e8f0',
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: '#fff',
  },
  imagePreview: {
    width: '100%',
    height: 160,
  },
  removeImageButton: {
    position: 'absolute',
    top: 4,
    right: 4,
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: 'rgba(226,75,74,0.9)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  removeImageText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 18,
  },
  uploadProgressOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 160,
    backgroundColor: 'rgba(0,0,0,0.55)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  uploadProgressText: {
    color: '#fff',
    fontSize: 20,
    fontWeight: 'bold',
  },
  previewFooter: {
    padding: 8,
  },
  imageName: {
    fontSize: 11,
    color: '#64748b',
    marginBottom: 2,
  },
  imageSize: {
    fontSize: 10,
    color: '#94a3b8',
  },
  uploadBarWrap: {
    height: 3,
    backgroundColor: '#e2e8f0',
    borderRadius: 2,
    marginTop: 4,
    overflow: 'hidden',
  },
  uploadBar: {
    height: 3,
    backgroundColor: '#378ADD',
    borderRadius: 2,
  },

  uploadingIndicator: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: 10,
    padding: 10,
    backgroundColor: '#E6F1FB',
    borderRadius: 8,
    borderWidth: 0.5,
    borderColor: '#B5D4F4',
  },
  uploadingText: {
    marginLeft: 8,
    fontSize: 13,
    color: '#185FA5',
    fontWeight: '500',
  },

  // ── Image Grid Styles with Overlay ─────────────────────────────────────────

  imageRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 12,
    paddingHorizontal: 4,
  },
  imageRowItem: {
    width: '31.33%',
    aspectRatio: 1,
    backgroundColor: '#f5f5f5',
    borderRadius: 8,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: '#e0e0e0',
    position: 'relative',
  },
  rowImage: {
    width: '100%',
    height: '100%',
  },
  imageOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    flexDirection: 'row',
    backgroundColor: 'rgba(0,0,0,0.7)',
    paddingVertical: 8,
    justifyContent: 'space-around',
  },
  imageActionBtn: {
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 4,
    minWidth: 50,
    alignItems: 'center',
  },
  updateBtn: {
    backgroundColor: '#4CAF50',
  },
  deleteBtn: {
    backgroundColor: '#f44336',
  },
  actionBtnText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: '600',
  },

  // ── Edit Image Modal Styles ─────────────────────────────────────────────────

  editImagePreview: {
    width: '100%',
    height: 200,
    borderRadius: 8,
    marginBottom: 10,
  },
  editDropzone: {
    border: '1.5px dashed #94a3b8',
    borderRadius: 12,
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    backgroundColor: '#f8fafc',
    marginTop: 10,
  },

  // ── Modal Styles ─────────────────────────────────────────────────────────────

  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 20,
    width: '90%',
    maxWidth: 500,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
    color: '#333',
  },
  modalFormGroup: {
    marginBottom: 15,
  },
  modalLabel: {
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 5,
    color: '#333',
  },
  modalPickerWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 8,
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  modalPicker: {
    height: 50,
    width: '100%',
    color: '#333',
  },
  modalInputWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 8,
    backgroundColor: '#fff',
  },
  modalTextInput: {
    height: 50,
    paddingHorizontal: 12,
    fontSize: 16,
    color: '#333',
  },
  modalButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    gap: 10,
  },
  modalButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  cancelButton: {
    backgroundColor: '#f5f5f5',
    borderWidth: 1,
    borderColor: '#ddd',
  },
  cancelButtonText: {
    color: '#666',
    fontSize: 16,
    fontWeight: '600',
  },
  updateButton: {
    backgroundColor: '#007bff',
  },
  updateButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
});
